import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  url?: string;
  active?: boolean;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <nav class="breadcrumb" aria-label="Breadcrumb">
      <ol class="breadcrumb-list">
        <li *ngFor="let item of items; let last = last" class="breadcrumb-item">
          <ng-container *ngIf="!last">
            <a *ngIf="item.url" [routerLink]="item.url" class="breadcrumb-link">
              {{ item.label }}
            </a>
            <span *ngIf="!item.url" class="breadcrumb-text">{{ item.label }}</span>
            <svg class="breadcrumb-separator" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </ng-container>
          <span *ngIf="last" class="breadcrumb-current">{{ item.label }}</span>
        </li>
      </ol>
    </nav>
  `,
  styles: [`

  
    .breadcrumb {
      display: flex;
      align-items: center;
      gap: 0.5rem; // space-x-2
      font-size: 0.875rem; // text-sm
      color: #6b7280; // text-gray-500
      margin-bottom: 1.5rem; // mb-6
    }

    .breadcrumb-list {
      display: flex;
      align-items: center;
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: 0.9rem;
    }

    .breadcrumb-item {
      display: flex;
      align-items: center;
    }

    .breadcrumb-link {
      color: #6b7280; // text-gray-500
      text-decoration: none;

      &:hover {
        color: #374151; // hover:text-gray-700
      }
    }

    .breadcrumb-link:hover {
      color: #0056b3;
      text-decoration: underline;
    }

    .breadcrumb-text {
      color: #666;
      font-weight: 500;
    }

    .breadcrumb-current {
        color: #111827; // text-gray-900
      }

    .breadcrumb-separator {
      color: #6b7280; // text-gray-500
      width: 24px;
      height: 24px;
    }

    @media (max-width: 768px) {
      .breadcrumb-list {
        font-size: 0.8rem;
      }

      .breadcrumb-separator {
        width: 14px;
        height: 14px;
        margin: 0 0.3rem;
      }
    }
  `]
})
export class BreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];
}
